import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';
import BasicTable from "./BasicTable";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '0px solid #000',
    boxShadow: 24,
    p: 1,
};

export interface BasicModalProps {
    title: string;
    serviceInfo: any;
}

const BasicModal = ({
    title,
    serviceInfo
}: BasicModalProps) => {

    const { t } = useTranslation("clinic");
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    if (serviceInfo === undefined) {
        return (<div>{t("modal.noServiceTime")}</div>);
    }
    return (
        <div>
            <Button onClick={handleOpen} style={{ color: '#0000ff', fontSize: '18px' }}>{t("modal.serviceTime")}</Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {title}
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                        <BasicTable serviceInfo={serviceInfo}></BasicTable>
                    </Typography>
                </Box>
            </Modal>
        </div>
    );
}

export default BasicModal;